import { TextDrawer, validTypes } from "./TextDrawer";
export async function loadTextShape(engine) {
    await engine.addShape(validTypes, new TextDrawer());
}
